module.exports = __webpack_public_path__ + "img/cover-mini-si-les-os-s-animent.a7c9ffe8.jpg";